@if (!isLoaded()) {
  <svg
    mat-card-image
    #fallback
    viewBox="0 0 158.75 158.75"
    version="1.1"
    id="svg1"
    class="npdc-fallback-img"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:svg="http://www.w3.org/2000/svg"
  >
    <defs id="defs1" />
    <g id="layer1">
      <path
        class="npdc-fallback-img__sky"
        d="M -0.99831936,-1.497479 -1.2478819,76.621163 C 67.641372,155.68873 60.27141,-3.8626856 158.73295,77.369954 l 0.24958,-78.36825604 z M 34.566882,47.170764 c 7.098695,-6.3e-5 12.853385,5.586889 12.853479,12.478825 -9.4e-5,6.891936 -5.754784,12.478888 -12.853479,12.478825 -7.098695,6.3e-5 -12.853385,-5.586889 -12.853479,-12.478825 9.4e-5,-6.891936 5.754784,-12.478888 12.853479,-12.478825 z"
      />
      <ellipse style="fill: none" cx="29.32563" cy="34.067646" rx="10.607142" ry="9.8584042" />
    </g>
    <g id="layer2" />
    <path
      id="path3"
      class="npdc-fallback-img__err"
      d="m 37.023452,32.503011 a 64.433521,64.059153 0 0 0 -5.049238,90.454209 64.433521,64.059153 0 0 0 90.982926,5.01994 64.433521,64.059153 0 0 0 5.04925,-90.4543 64.433521,64.059153 0 0 0 -90.982938,-5.019849 z m 8.229549,9.143165 A 44.954922,51.416656 49.419563 0 1 68.488859,29.036373 44.954922,51.416656 49.419563 0 1 113.7417,40.888154 L 36.916812,109.23495 A 44.954922,51.416656 49.419563 0 1 30.076393,63.209789 44.954922,51.416656 49.419563 0 1 45.253001,41.646176 Z m 1.042657,78.008904 76.824862,-68.346754 a 44.954922,51.416656 49.419563 0 1 6.84138,46.0261 A 44.954922,51.416656 49.419563 0 1 91.549476,131.5078 44.954922,51.416656 49.419563 0 1 46.295658,119.65508 Z"
    />
  </svg>
}

@if (!hasError()) {
  <img
    mat-card-image
    alt="{{ alt }}"
    src="{{ src }}"
    [class.is-loaded]="isLoaded()"
    (load)="isLoaded.set(true)"
    (error)="hasError.set(true)"
  />
}
